import React from 'react';
import { Form } from '@dashboard/components/Formik';
import usePage from '@dashboard/hooks/usePage';
import getProductType, { PRODUCT_TYPES } from '@dashboard/services/getProductType';

const DynamicPricingForm = () => {
  const { page, updatePage } = usePage();

  return (
    <Form
      autosave
      showState={false}
      initialValues={{
        allowDynamicPrice: page.allowDynamicPrice,
        allowDynamicPlanIterations: page.allowDynamicPlanIterations,
        allowDynamicDiscountedFromPrice: page.allowDynamicDiscountedFromPrice,
        allowDynamicTitle: page.allowDynamicTitle,
        allowDynamicDescription: page.allowDynamicDescription,
      }}
      fields={[
        {
          type: 'fieldgroup',
          fields: [
            {
              type: 'label',
              label: 'Allow dynamic',
            },
            {
              name: 'allowDynamicTitle',
              type: 'checkbox',
              label: 'Title',
            },
            ...(page.type === 'checkout'
              ? [
                  {
                    name: 'allowDynamicPrice',
                    type: 'checkbox',
                    label: 'Price',
                  },
                  ...(getProductType(page.product) === PRODUCT_TYPES.PAYMENT_PLAN ||
                  getProductType(page.product) === PRODUCT_TYPES.SUBSCRIPTION
                    ? [
                        {
                          name: 'allowDynamicPlanIterations',
                          type: 'checkbox',
                          label: 'No. of payments',
                        },
                      ]
                    : []),
                  {
                    name: 'allowDynamicDiscountedFromPrice',
                    type: 'checkbox',
                    label: 'Discounted from price',
                  },
                ]
              : []),
            {
              name: 'allowDynamicDescription',
              type: 'checkbox',
              label: 'Description',
            },
          ],
        },
      ]}
      submitButton={{
        label: 'Save',
      }}
      onSubmit={async values => {
        const { data, error } = await updatePage.mutateAsync(values);

        return {
          data,
          error,
        };
      }}
    />
  );
};

export default DynamicPricingForm;
